import "./AiAgents.scss";

import AiAgentsImg from "../../assets/images/ai-agents.png";
import AiAgentsDecoration from "../../assets/images/ai-agents-decoration.png";

export default function AiAgents() {
	return (
		<div className="ai-agents" id="ai-agents">
			<div className="ai-agents-content-wrapper content-wrapper-lg">
				<img
					className="decoration ai-agents-decoration shake-slow-4"
					src={AiAgentsDecoration}
					alt="AI Agents Decoration"
				/>
				<div className="ai-agents-content">
					<h3 className="ai-agents-title" data-aos="zoom-in">
						AI Agents
					</h3>
					<div
						className="ai-agents-desc"
						data-aos="fade-up"
						data-aos-delay="50"
					>
						<p>
							Iris Al isn't just another tool—it's a smarter, more
							intuitive way to use Al. While many Al agents
							automate basic tasks, Iris Al's agents learn, adapt,
							and think autonomously to help you get things done
							faster and more efficiently. Whether you're creating
							content, analyzing markets, or conducting research,
							Iris Al's flexibility and deep customization make it
							the perfect fit for your needs.
						</p>

						<p>
							Choose Iris Al for a smarter, more personalized
							experience. Our agents don't just work for you—they
							work with you, helping you make better decisions and
							achieve more.
						</p>
					</div>
				</div>

				<div className="ai-agents-img">
					<img src={AiAgentsImg} alt="AI Agents" />
				</div>
			</div>
		</div>
	);
}
